import Chevron from '../Chevron/Chevron'
import { useState } from 'react'
import { PRIMARY } from '../../styles/colors'
import * as S from './SimpleDropdown.styles'

export type SimpleDropdownProps = {
  placeholder: string
  options: string[]
  value?: string
  onChange?: (value: string) => void
}

export default function SimpleDropdown({
  placeholder,
  options,
  value,
  onChange
}: SimpleDropdownProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleSelect = (option: string) => {
    onChange?.(option)
    setIsOpen(false)
  }

  return (
    <S.Container>
      <S.DropdownButton onClick={() => setIsOpen(!isOpen)}>
        <S.DropdownText>
          {value || placeholder}
        </S.DropdownText>
        <Chevron
          direction={isOpen ? 'up' : 'down'}
          color={PRIMARY}
          size={8}
          strokeWidth={2}
        />
      </S.DropdownButton>

      {isOpen && (
        <S.DropdownMenu>
          {options.map((option, index) => (
            <S.OptionItem
              key={index}
              onClick={() => handleSelect(option)}
              $isLast={index === options.length - 1}
            >
              <S.OptionText>
                {option}
              </S.OptionText>
              {value === option && (
                <S.CheckIcon width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d="M16.6667 5L7.50004 14.1667L3.33337 10"
                  />
                </S.CheckIcon>
              )}
            </S.OptionItem>
          ))}
        </S.DropdownMenu>
      )}
    </S.Container>
  )
}
